export default __webpack_public_path__ + "598fcab1e38be655c6362b8308d6c72d.svg";